const userGlobalConfig = {
  TOKEN: "ADMIN_LOGIN_TOKEN",
  ROLE: "ADMIN_LOGIN_ROLE",
  USER_ID: "USER_ID",
  JOURNEY_ID: "JOURNEY_ID",
  SKILL_ID: "SKILL_ID",
  STEP_ID: "STEP_ID",
  SUB_STEP_ID: "SUB_STEP_ID",
  EXERCISE_ID: "EXERCISE_ID",
  TAB_TYPE: "TAB_TYPE",
  TAB_TYPE_SKILL: "TAB_TYPE_SKILL",
  REVIEW_SKILL_ID: "REVIEW_SKILL_ID",
};

export default userGlobalConfig;
